/**
 * @generated SignedSource<<e2726e7fe656e8f749fe8bd3418491ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksPaywallPromiseArticle$data = {
  readonly entityId: string;
  readonly " $fragmentType": "hooksPaywallPromiseArticle";
};
export type hooksPaywallPromiseArticle$key = {
  readonly " $data"?: hooksPaywallPromiseArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksPaywallPromiseArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksPaywallPromiseArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "57ac42de347b7a1276a4ba29d9356095";

export default node;
